/**
 * Created by mohit.chavda on 3/2/2017.
 */
import {Injectable} from "@angular/core";
import {CanActivate, Router, RouterStateSnapshot, ActivatedRouteSnapshot} from "@angular/router";
import {Observable} from "rxjs/Rx";
import {LocalStorageService} from "../services/LocalStorage.service";
import {ROUTE_CONSTANTS} from "../common/constant/RouteConstants";
import {ONLINE_APP_CONSTANTS} from "./constant/OnlineAppConstants";

@Injectable()
export class OnlineServiceAuthGuard implements CanActivate {

  constructor(protected router: Router,
              private _localStorageService : LocalStorageService)
  {

  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {

    console.log("CHECK AUTH ROUTE..." + this._localStorageService.isUserLoggedIn());

    var isSubmitURL:boolean = false;
    if(state.url == ROUTE_CONSTANTS.TIU_SUCCESS_SUBMIT
      || state.url == ROUTE_CONSTANTS.JD_SUCCESS_SUBMIT)
    {
      isSubmitURL = true;
    }
    var isSubmitStorage:boolean = this._localStorageService.getIsSubmit();
        
    var appID:number = this._localStorageService.getApplicationID();
    
    var isAppListViewPath:boolean = false;
    if(state.url == ONLINE_APP_CONSTANTS.ROUTE_PATH_APPLICATION+ ONLINE_APP_CONSTANTS.ROUTE_PATH_APPLICATION_LIST)
    {
      isAppListViewPath = true;
    }
    var isNewApp:boolean = false;
    if(this._localStorageService.getItem(ONLINE_APP_CONSTANTS.LOCAL_STORAGE_APPLICATION_IS_NEW) == true)
    {
      isNewApp = true;
    }
    
    
    /*console.log('==============[[==============');
    console.log('state.url :' + state.url);
    console.log('isSubmitURL: '+ isSubmitURL);
    console.log('isSubmitStorage: '+ isSubmitStorage);
    console.log('==============]]==============');*/

    if(this._localStorageService.isUserLoggedIn() &&
      this._localStorageService.getUserId() > 0)
    {
      console.log("1. In Same Page");
      if((state.url == ROUTE_CONSTANTS.LOGIN ||
        state.url == ROUTE_CONSTANTS.CREATE_NEW_USER ||
        state.url == ROUTE_CONSTANTS.WELCOME ||
        state.url == ROUTE_CONSTANTS.ROOT)
        || (isSubmitURL == false && isSubmitStorage == true &&
        state.url != (ONLINE_APP_CONSTANTS.ROUTE_PATH_APPLICATION+ ONLINE_APP_CONSTANTS.ROUTE_PATH_APPLICATION_LIST)))
      {
        console.debug("LOGIN USER ROOT WELCOME PAGE Redirect To App List: ");
        this.navigateToAppList();
        return false;
      }
      else
      {
        console.debug("Validate  Route for Other URL : "+this._localStorageService.getUserId());
        if(isSubmitURL == true && isSubmitStorage == false)
          return false;
        else {
          if(isAppListViewPath == false 
            && (appID == 0 && isNewApp == false))
          {
            this.navigateToAppList();
            return false;  
          }
          else 
          {
            return true;
          }
        }
      }
    }
    else if(this._localStorageService.isUserLoggedIn() == false &&
      this._localStorageService.getIsRemember() == false)
    {
      console.log("2. Fresh App or First time open URL");
      if(state.url == ROUTE_CONSTANTS.LOGIN ||
        state.url == ROUTE_CONSTANTS.CREATE_NEW_USER ||
        state.url == ROUTE_CONSTANTS.WELCOME ||
        state.url == ROUTE_CONSTANTS.ROOT) {
        console.log("2.0 LOGIN USER ROOT WELCOME PAGE ");
        return true;
      }
      else
      {
        console.log("2.1 OTHER THAN LOGIN USER ROOT WELCOME PAGE ");
        this.navigateToHome();
        return false;
      }
    }
    else if(this._localStorageService.isUserLoggedIn() == true &&
      this._localStorageService.getIsRemember() == false)
    {
      console.log("3. Open App in New Tab without is remember = true");
      if(!(state.url == ROUTE_CONSTANTS.LOGIN ||
        state.url == ROUTE_CONSTANTS.CREATE_NEW_USER ||
        state.url == ROUTE_CONSTANTS.WELCOME ||
        state.url == ROUTE_CONSTANTS.ROOT)) {
        console.log("3.0 Navigate to Home");
        this.navigateToHome();
        return false;
      }
      else
      {
        console.log("3.1");
        //return true;
        if(isAppListViewPath == false
          && (appID == 0 && isNewApp == false))
        {
          this.navigateToAppList();
          return false;
        }
        else
        {
          return true;
        }
      }
    }
    else
    {
      console.log("4. PENDING SCENARIO");
      //console.log("4.1 IS REMEMBER TRUE, OPEN PAGE IN NEXT TAB HANDLE IN APP COMPONENT TS FILE");
      /*console.log(this._localStorageService.isUserLoggedIn());
       console.log(this._localStorageService.getUserId());
       console.log(this._localStorageService.getIsRemember());*/
      return true;
    }
  }
  navigateToAppList()
  {
    //this.router.navigate([ONLINE_APP_CONSTANTS.COM_APPLICATION_LIST+ ONLINE_APP_CONSTANTS.ROUTE_PATH_APPLICATION_LIST]);
    this.router.navigate([ONLINE_APP_CONSTANTS.ROUTE_PATH_APPLICATION+ ONLINE_APP_CONSTANTS.ROUTE_PATH_APPLICATION_LIST]);
  }
  navigateToHome(){
    this.router.navigate([ROUTE_CONSTANTS.ROOT]);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/OnlineServiceAuthGuard.ts